import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

import pvzSrc from '../../assets/night/pvz.svg'
import sourceSrc from '../../assets/night/source.svg'
import yandexMarketSrc from '../../assets/yandexMarket.png'
import type {PointMarkerType} from './types'

const STICK_WIDTH = 3
const STICK_HEIGHT = 16
const SHADOW_WIDTH = 12
const SHADOW_HEIGHT = 6
const LEVITATING_HEIGHT = 8

export const marker = css`
  transform: translate(-50%, -100%);
`
export const icon = css`
  min-width: ${spacing(4)};
  height: ${spacing(4)};
  border: ${spacing(0.25)} solid ${cssTheme.default.day.background};
  background: no-repeat center center ${cssTheme.colors.deliveryGrey[450]};
  background-size: ${spacing(2.5)};
  color: ${cssTheme.default.day.background};
  border-radius: ${spacing(1.25)};
`
export const iconType: Partial<Record<PointMarkerType, string>> = {
  numeric: css`
    padding: ${spacing(0, 1)};
    border-radius: ${spacing(6.5)};
  `,
  yandex_market: css`
    background-image: url(${yandexMarketSrc});
    background-size: contain;
  `,
  pickup_point: css`
    background-image: url(${pvzSrc});
  `,
  source: css`
    background-image: url(${sourceSrc});
  `,
}
export const draggable = css`
  transition: all 0.3s ease-in;
`
export const dragging = css`
  transform: translateY(-${LEVITATING_HEIGHT}px);
`
export const stick = css`
  position: relative;
  inline-size: ${STICK_WIDTH}px;
  block-size: ${STICK_HEIGHT}px;
  background-color: ${cssTheme.default.day.text};
  border-radius: ${spacing(0, 0, 1, 1)};
  margin: 0 auto;

  &::after {
    content: '';
    position: absolute;
    inline-size: ${SHADOW_WIDTH}px;
    block-size: ${SHADOW_HEIGHT}px;
    border-radius: 100%;
    background: rgba(0, 0, 0, 0.2);
    filter: blur(1px);
    inset-inline-start: -${SHADOW_WIDTH / 2 - STICK_WIDTH / 2}px;
    inset-block-start: calc(100% - ${SHADOW_HEIGHT / 2}px);
    transition: all 0.3s ease-in;
  }
`
export const stickDragging = css`
  &::after {
    filter: blur(4px);
    inset-block-start: calc(100% - ${SHADOW_HEIGHT / 2 - LEVITATING_HEIGHT}px);
  }
`
